/** The last level each companion was SHOWN at, shared by the Habitat's level-up celebration
 *  (HabitatScreen) and the battle victory card (Demo I). The victory card marks the level it
 *  animated, so returning to the Habitat does not raise the same level-up twice. Module state,
 *  written only from effects (CLAUDE.md "Lesson 1"). */
const seen = new Map<number, number>();

export function getSeenLevel(companionId: number): number | null {
  return seen.get(companionId) ?? null;
}

export function markLevelSeen(companionId: number, level: number): void {
  const prev = seen.get(companionId);
  if (prev == null || level > prev) seen.set(companionId, level);
}

/** Forget every seen level — called on logout (MeScreen) so account B is never diffed against
 *  account A's levels. */
export function resetLevelBaseline(): void {
  seen.clear();
}

/** Test alias, kept so existing suites read unchanged. */
export const resetLevelBaselineForTests = resetLevelBaseline;
